import 'css-chunksrc/client/scenes/projectMembersListingConfiguration/styles.scss';export default {
  "projectMembersListingConfiguration": "_projectMembersListingConfiguration_10wlt_1",
  "main": "_main_10wlt_8",
  "tabs": "_tabs_10wlt_14",
  "tab": "_tab_10wlt_14",
  "selectedTab": "_selectedTab_10wlt_34",
  "label": "_label_10wlt_41",
  "footer": "_footer_10wlt_48",
  "button": "_button_10wlt_63"
};